var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

function fetchBlob(url, progressCallback, requestInit) {
  var _a, _b;

  return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var _this = this;

    var response, reader, contentLength, receivedLength, processChunk;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(url, requestInit);

          case 2:
            response = _context2.sent;
            reader = (_a = response.clone().body) === null || _a === void 0 ? void 0 : _a.getReader();
            contentLength = Number((_b = response.headers) === null || _b === void 0 ? void 0 : _b.get('Content-Length'));
            receivedLength = 0; // Process the data

            processChunk = function processChunk(done, value) {
              return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var percentage;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!done) {
                          _context.next = 2;
                          break;
                        }

                        return _context.abrupt("return");

                      case 2:
                        // Add to the received length
                        receivedLength += (value === null || value === void 0 ? void 0 : value.length) || 0;
                        percentage = Math.round(receivedLength / contentLength * 100);
                        progressCallback(percentage); // Continue reading data

                        return _context.abrupt("return", reader === null || reader === void 0 ? void 0 : reader.read().then(function (_ref) {
                          var done = _ref.done,
                              value = _ref.value;
                          return processChunk(done, value);
                        }));

                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
            };

            reader === null || reader === void 0 ? void 0 : reader.read().then(function (_ref2) {
              var done = _ref2.done,
                  value = _ref2.value;
              return processChunk(done, value);
            });
            return _context2.abrupt("return", response.blob());

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

var Fetcher = {
  fetchBlob: fetchBlob
};
export default Fetcher;